import React, { Fragment } from 'react';

import PropTypes from "prop-types";
import styled from "styled-components";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

import {
  getSizesProfileList,
  selectSizeProfile,
  changeSizeScenario,
} from '../../actions/sizes';

import SmartSizeForm from "../FormSmartSize";
import StandartSizeForm from "../FormStandartSize";
import MeasureSizeForm from "../FormMeasureSize";
import { Menu, MenuItem } from '../ui/Menu';

import MeasureForSmartOptions from '../BuilderSize/measuresFromSmartOptions';
import MeasureForTableOptions from '../BuilderSize/measuresFromTableOptions';

import ClearIcon from '../../components/icons/ClearIcon';
import BackIcon from '../icons/BackIcon';

const CloseButton = styled.button`
    padding: 5px;
    margin: 0 0 0 auto;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
    cursor: pointer;
    outline: none;

    position: absolute;
    z-index: 2;
    right: 10px;
    top: 10px;
`
const BackButton = styled.button`
    padding: 5px;
    margin: 0 0 0 auto;
    border: none;
    box-sizing: border-box;
    background-color: transparent;
    cursor: pointer;
    outline: none;

    position: absolute;
    z-index: 2;
    left: 10px;
    top: 10px;
`

const MobileTitle = styled.p`
  font-size: 16px;
  padding: 6px; 
  margin-top: 40px;
  text-align: center;
`

class BuilderSize extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openAttr: false,
      selectedAttr: '',
      openPopup: false,
    }
  }

  selectAttr = (value) => {
    this.setState({ openAttr: true, selectedAttr: value })
  }

  closeAttr = () => {
    this.setState({ openAttr: false, selectedAttr: false })
  }

  onSmartMarkClick = () => {
    const attr = 'smart';
    this.setState({
      selectedAttr: attr,
      openAttr: true,
    })
  }

  onSizeProfileSelect = (profile) => {
    this.props.sizeActions.selectSizeProfile(profile)
    this.props.sizeActions.changeSizeScenario('profile')
  }

  componentDidMount = async () => {
    await this.props.sizeActions.getSizesProfileList();
  }

  onLogin = () => {
    const button = document.getElementById('enter-link');
    if (button) {
      button.click();
    }
  }

  getCurrentAttrText = selectedAttr => {
    return selectedAttr === 'smart' ? 'Умная мерка' :
      selectedAttr === 'measure' ? 'Снять размеры с тела' :
        selectedAttr === 'standart' ? 'Стандартные размеры' : 'Размеры'
  }

  onAfterMeasureSubmit = async () => {
    this.closeAttr();
    this.props.toggle();
  }

  render() {
    const { toggle, isMobile } = this.props;

    const { selectedAttr, openAttr } = this.state
    const currentText = this.getCurrentAttrText(selectedAttr);

    let menu = (
      <Menu value={selectedAttr} onChange={this.selectAttr}>
        <MenuItem
          className='config-options-wrapper__menu-item'
          onClick={this.onSmartMarkClick}
          value={'smart'}
        >
          <p>Умная мерка
          <span className='b-rit-smart-mark__bage'>
              Выбор покупателей
          </span></p>
          <span className="config-options-wrapper__menu-item-description">
            Введите всего 3 параметра и мы сами определим ваш размер
          </span>
        </MenuItem>
        <MenuItem
          className='config-options-wrapper__menu-item'
          onClick={this.onMenuClick}
          value={'measure'}
        >
          <p>Снять размеры с тела</p>
          <span className="config-options-wrapper__menu-item-description">
            При помощи наших видео и инструкций, создайте индивидуальный профиль размеров для лучшей посадки рубашки
          </span>
      </MenuItem>
        <MenuItem
          className='config-options-wrapper__menu-item'
          onClick={this.onMenuClick}
          value='standart'
        >
          <p>Стандартные размеры</p>
          <span className="config-options-wrapper__menu-item-description">
            Выберите наиболее подходящий вам размер из представленных
          </span>
      </MenuItem>
      </Menu>
    )

    let content = null;
    if (!selectedAttr) {
      content = (
        <div className='config-options-wrapper__size-attr'>
          <section>
            {menu}
          </section>
        </div>
      )
    } else {
      content = (
        <Fragment>
          <div className='config-header'>
            {currentText}
          </div>
          {selectedAttr == 'smart' &&
            <div className='b-rit-section'>
              <SmartSizeForm
                closeAttr={this.closeAttr}
              />
              <MeasureSizeForm
                hideInfo={true}
                containExpertMode={false}
                sizeOptions={MeasureForSmartOptions}
                onAfterSubmit={this.onAfterMeasureSubmit}
                closeAttr={this.closeAttr}
              />
            </div>
          }
          {selectedAttr == 'measure' &&
            <div className='b-rit-section'>
              <MeasureSizeForm
                hideInfo={false}
                containExpertMode={true}
                sizeOptions={MeasureForTableOptions}
                onAfterSubmit={this.onAfterMeasureSubmit}
                closeAttr={this.closeAttr}
              />
            </div>
          }
          {selectedAttr == 'standart' &&
            <StandartSizeForm 
              onAfterSubmit={this.onAfterMeasureSubmit}
              closeAttr={this.closeAttr}
              buttonSize={'30em'}
            />
          }
        </Fragment>
      )
    }

    return (
      <section className="config-options-wrapper">
        {openAttr && <BackButton
            onClick={this.closeAttr}>
          <BackIcon size={15} color="currentColor" />
        </BackButton>}
        
        <CloseButton
            onClick={toggle}>
            <ClearIcon style={isMobile ? {width:'1em', height:'1em'} : {width:'1.25em', height:'1.25em'}} />
        </CloseButton>
        {isMobile && selectedAttr && <MobileTitle className='fabric-builder__title'>
            {currentText}
          </MobileTitle>}
        {content}
      </section>
    );
  }
}

BuilderSize.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  sizeActions: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    isMobile: state.ui.isMobile,
  }
}


function mapDispatchToProps(dispatch) {
  return {
    sizeActions: bindActionCreators({
      getSizesProfileList,
      selectSizeProfile,
      changeSizeScenario
    }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(BuilderSize));